"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReportsByOrganization = void 0;
const getDashboardGeneratorApiUrl = () => {
    if (process.env.DG_API_URL && process.env.DG_API_URL != '') {
        return process.env.DG_API_URL;
    }
    else {
        throw new Error('[DG-API] Missing Environment Configuration. Take a look at environment variables');
    }
};
const getPackageInfo = (accessToken, callback, onError) => {
    try {
        fetch(`${getDashboardGeneratorApiUrl()}/api/v1/packages`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then(result => result.json())
            .then(data => callback(data));
    }
    catch (e) {
        console.log(`getPackageInfo Error: ${e}`);
        onError && onError(e);
    }
};
const getPackages = (templateName, templateVersion, accessToken, callback, onError) => {
    try {
        fetch(`${getDashboardGeneratorApiUrl()}/api/v1/templates/packages?templateName=${templateName}&templateVersion=${templateVersion}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => callback(result));
    }
    catch (e) {
        console.log(`getPackages Error: ${e}`);
        onError && onError(e);
    }
};
const getReportByID = (reportID, accessToken, callback, onError) => {
    try {
        fetch(`${getDashboardGeneratorApiUrl()}/api/v1/reports/${reportID}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => callback(result));
    }
    catch (e) {
        console.log(`getReportByID Error: ${e}`);
        onError && onError(e);
    }
};
const getReportTypeData = (accessToken, callback, onError) => {
    try {
        fetch(`${getDashboardGeneratorApiUrl()}/api/v1/reportTypes`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then(result => result.json())
            .then(data => callback(data));
    }
    catch (e) {
        console.log(`getReportTypeData Error: ${e}`);
        onError && onError(e);
    }
};
const getReportsByOrganization = (organizationId, accessToken, callback, onError) => {
    try {
        fetch(`${getDashboardGeneratorApiUrl()}/api/v1/reports?organizationIdRequested=${organizationId}&organizationId=${organizationId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => callback(result));
    }
    catch (e) {
        console.log(`getReportsByOrganization Error: ${e}`);
        onError && onError(e);
    }
};
exports.getReportsByOrganization = getReportsByOrganization;
const getReportsForUser = (templateName, templateVersion, accessToken, callback, onError) => {
    try {
        fetch(`${getDashboardGeneratorApiUrl()}/api/v1/reports?templateName=${templateName}&templateVersion=${templateVersion}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => callback(result));
    }
    catch (e) {
        console.log(`getReportsByOrganizationID Error: ${e}`);
        onError && onError(e);
    }
};
const getReportPublishStatus = (reportId, accessToken, callback, onError) => {
    try {
        fetch(`${getDashboardGeneratorApiUrl()}/api/v1/reports/${reportId}/publish_status`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => callback(result));
    }
    catch (e) {
        console.log(`publishReportById Error: ${e}`);
        onError && onError(e);
    }
};
const updateReportPublishStatus = (reportId, published, accessToken, callback, onError) => {
    try {
        console.log(`Updating report ${reportId} publish status to ${published}`);
        fetch(`${getDashboardGeneratorApiUrl()}/api/v1/reports/${reportId}/publish_status`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(published),
            credentials: 'include',
        })
            .then(response => response && response.json())
            .then(result => callback(result))
            .catch(err => {
            console.log(`updateReportPublishStatus: ${err}`);
            callback(null);
        });
    }
    catch (e) {
        console.log(`publishReportById Error: ${e}`);
        onError && onError(e);
    }
};
const updateReportById = (reportId, updatedReport, accessToken, callback, onError) => {
    try {
        fetch(`${getDashboardGeneratorApiUrl()}/api/v1/reports/${reportId}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(updatedReport),
            credentials: 'include',
        })
            .then(response => response.json())
            .then(result => callback(result));
    }
    catch (e) {
        console.log(`updateReportById Error: ${e}`);
        onError && onError(e);
    }
};
const updateReportPackage = (reportId, packageId, accessToken, callback, onError) => {
    try {
        fetch(`${getDashboardGeneratorApiUrl()}/api/v1/reports/${reportId}/package`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: packageId,
            credentials: 'include',
        })
            .then(result => callback(result));
    }
    catch (e) {
        console.log(`updateReportPackage Error: ${e}`);
        onError && onError(e);
    }
};
const getChartsWithFeedback = (reportId, accessToken, callback, onError) => {
    try {
        fetch(`${getDashboardGeneratorApiUrl()}/api/v1/reports/${reportId}/charts_with_feedback`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        })
            .then(result => callback(result));
    }
    catch (e) {
        console.log(`getChartsWithFeedback Error: ${e}`);
        onError && onError(e);
    }
};
/**
 * TODO - Update this implementation
 * Currently we have to perform two calls in order to get the report takeaways:
 * {${getDashboardGeneratorApiUrl()}/api/v1/reports/${reportId}/charts_with_feedback} - To get the charts with recommendations
 * {${getDashboardGeneratorApiUrl()}/api/v1/reports/${reportId}} - To get report key takeaways
 *
 * We should have a single endpoint that returns the takeaways/recommendations for a given report
 */
const getReportTakeaways = (reportId, accessToken, callback, onError) => {
    try {
        Promise.all([
            fetch(`${getDashboardGeneratorApiUrl()}/api/v1/reports/${reportId}/charts_with_feedback`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            }),
            fetch(`${getDashboardGeneratorApiUrl()}/api/v1/reports/${reportId}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            }),
        ])
            .then(([chartsWithFeedback, report]) => {
            return Promise.all([chartsWithFeedback.text(), report.json()]);
        })
            .then(([chartsWithFeedback, report]) => {
            callback([...JSON.parse(chartsWithFeedback), ...report.reportTakeaways]);
        });
    }
    catch (e) {
        console.log(`getReportTakeaways Error: ${e}`);
        onError && onError(e);
    }
};
const DashboardGeneratorServices = {
    getPackageInfo,
    getPackages,
    getReportByID,
    getReportTypeData,
    getReportsByOrganization: exports.getReportsByOrganization,
    getReportsForUser,
    getReportPublishStatus,
    updateReportPublishStatus,
    updateReportById,
    updateReportPackage,
    getChartsWithFeedback,
    getReportTakeaways,
};
exports.default = DashboardGeneratorServices;
